import axioPath from "api/axioPath";
import { UPDATE_DATA } from "redux/actions/action_types";

export const dashboardTableRecords = (data, locationType, customerId, token) => (dispatch) => {
  return axioPath.post(`/order/dashboard_order/${customerId}/${locationType}`, data, {
    headers: {
      Authorization: `${token}`,
      UserType: "external"
    },
  })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data, apiType: "form" });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};
export const orderChart = (customerId, selectType, token) => (dispatch) => {
  return axioPath.get("order/" + customerId + "/order_chart/" + selectType, {
    headers: {
      Authorization: token,
      UserType: 'external',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const qtySpendChartApi = (data, token) => (dispatch) => {
  return axioPath.post("dashboard/order_graph", data, {
    headers: {
      Authorization: token,
      UserType: 'external',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const palletMixPieChartApi = (data, token) => (dispatch) => {
  return axioPath.post("dashboard/pallet_mix", data, {
    headers: {
      Authorization: token,
      UserType: 'external',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const buyBackDetailsDashboardApi = (data, token) => (dispatch) => {
  return axioPath.post("dashboard/buyback_info", data, {
    headers: {
      Authorization: token,
      UserType: 'external',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};